/* lv-content · live rating distribution for the review page.
   Reads the public Klaviyo reviews endpoint (the same one the reviews widget reads). The server-rendered number, stars and count
   from the product's review metafields stay in place if the request fails. */
(function () {
  document.querySelectorAll('[data-lvc-agg]').forEach(function (box) {
    var src = box.getAttribute('data-src');
    if (!src) return;
    fetch(src).then(function (r) { return r.json(); }).then(function (d) {
      var p = (d && (d.summary || d.product)) || {};
      var h = p.rating_histogram, n = +p.review_count, avg = +p.star_rating;
      if (!n || !avg) return;
      var num = box.querySelector('[data-agg-num]'), count = box.querySelector('[data-agg-count]');
      var stars = box.querySelector('.lvc-stars'), bars = box.querySelector('[data-agg-bars]');
      if (num) num.textContent = avg.toFixed(2).replace(/0$/, '');
      if (count) count.textContent = n + ' ' + (count.getAttribute('data-suffix') || 'reviews');
      if (stars) { stars.style.setProperty('--v', avg.toFixed(2)); stars.setAttribute('aria-label', avg.toFixed(2) + ' out of 5 stars'); }
      if (bars && Array.isArray(h) && h.length === 5) {
        bars.textContent = '';
        [5, 4, 3, 2, 1].filter(function (s) { return h[s - 1] > 0; }).forEach(function (s) {
          var pct = Math.round(h[s - 1] / n * 100);
          var li = document.createElement('li');
          li.setAttribute('aria-label', s + ' stars: ' + (pct < 1 ? 'under 1' : pct) + ' percent');
          var a = document.createElement('span'); a.textContent = s + ' ★';
          var tr = document.createElement('i'), fill = document.createElement('b');
          fill.style.width = Math.max(1, h[s - 1] / n * 100) + '%'; tr.appendChild(fill);
          var c = document.createElement('span'); c.textContent = (pct < 1 ? '<1' : pct) + ' %';
          li.appendChild(a); li.appendChild(tr); li.appendChild(c); bars.appendChild(li);
        });
      }
    }).catch(function () {});
  });
})();
